<template>
  <DialogContent class="flex flex-col items-center">
    <div
      class="mt-[18px] font-primary font-semibold text-[34px] leading-[50px] mb-4"
    >
      Welcome back!
    </div>
    <div
      class="font-secondary text-[16px] leading-[24px] text-gray-500 text-center mb-6"
    >
      <template v-if="hasOutstandingBalance">
        To restore your account and add new files you need to pay the accrued
        balance. We've maintained your copyrighted work and information.
      </template>
      <template v-else>
        Your account has been restored. We've maintained your copyrighted work
        and information.
      </template>
    </div>
    <Lottie name="Infinite-Files" class="min-w-[1875px]" loop />
  </DialogContent>
  <DialogFooter class="flex justify-center">
    <template v-if="hasOutstandingBalance">
      <UiButton class="tablet-h:mr-2" large @click="close()"> Cancel </UiButton>
      <UiButton
        class="w-1/2 tablet-h:w-auto"
        primary
        large
        @click="handleClick"
      >
        Pay balance
      </UiButton>
    </template>

    <template v-else>
      <UiButton primary large @click="close()"> Continue </UiButton>
    </template>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import Lottie from '@/shared/components/Lottie.vue'
import { useBillingStore } from '@/features/billing/store'
import { computed } from 'vue'

const { close, open } = useDialog()
const billingStore = useBillingStore()

const hasOutstandingBalance = computed(() =>
  billingStore.billing?.upcomingDetails.upcomingBilling?.breakdown.some(
    (breakdown) => breakdown.outstanding
  )
)

const handleClick = () => {
  open(Dialogs.Pay, {
    events: {
      success() {
        open(Dialogs.Success, {
          props: {
            title: 'Payment successful',
          },
          events: {
            success() {
              close()
            },
          },
        })
      },
    },
  })
}
</script>
